import React from 'react';
import { Row, Col, message } from 'antd';
import { I18n } from '@aws-amplify/core';

import { TASKS_FILTER } from './Filters';
import { useOWASContext } from '../../context';
import { Button } from '@/components/ui/Button';
import { useOwasEvaluationContext } from './context';
import { useValidateOWASEvaluation } from '../../hooks/useValidateOwasEvaluation';

export function Footer(): JSX.Element {
	const { onFilterAnalyzed } = useOwasEvaluationContext();
	const { isLoading, mutateAsync: validateStep } = useValidateOWASEvaluation();
	const { handleNextStep, handlePreviousStep, data, parameters } = useOWASContext();

	async function handleOnSumit(): Promise<void> {
		try {
			await validateStep({
				organization_id: parameters?.organization_id!,
				company_id: parameters?.company_id!,
				file_id: parameters?.file_id!,
				report_id: data?.id!
			});

			handleNextStep();
		} catch (error: any) {
			const errorMessage = error?.response?.data?.message ?? 'Perform the evaluation of the tables';
			onFilterAnalyzed(TASKS_FILTER.NOT_ANALYZED);
			message.error(I18n.get(errorMessage));
		}
	}
	return (
		<Row justify="center" gutter={[24, 0]}>
			<Col>
				<Button type="ghost" onClick={handlePreviousStep} disabled={isLoading}>
					{I18n.get('Back')}
				</Button>
			</Col>
			<Col>
				<Button type="primary" onClick={handleOnSumit} loading={isLoading}>
					{I18n.get('Next')}
				</Button>
			</Col>
		</Row>
	);
}
